import { FC } from 'react';
import { Policy } from '@agilelab/plugin-wb-governance-common';
import { Box, makeStyles, Typography, useTheme } from '@material-ui/core';
import { DetailIcon } from '../TestTable/DetailIcon';
import { Task } from '../types';

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

interface Props {
  policy: Policy;
  task: Task;
}

export const PolicyHeader: FC<Props> = ({ policy, task }) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Box className={classes.header} style={{ marginBottom: theme.spacing(2) }}>
      <Box style={{ display: 'flex', alignItems: 'center' }}>
        <DetailIcon
          status={task.status}
          policyStatus={task.governanceEntityStatus}
          severity={policy.severity}
        />
        <Typography variant="h6">
          <strong style={{ color: theme.palette.primary.main }}>
            {`Policy ${policy.name}`}
          </strong>
        </Typography>
      </Box>
    </Box>
  );
};
